export default {
    // Sidebar
    'Nova OS Proativa': 'Nieuw Proactief WO',
    'Interno': 'Intern',
    'Externo': 'Extern',
    "Preventiva": "Preventief",
    "Preventiva Programada":  "Geplande preventieve onderhoud",
    "Preventivas Armazém":  "Preventieve Magazijn",
    "Preventiva Programada Armazém": "Geplande preventieve onderhoud Magazijn",
    'Reaberta': 'Heropend',
    'Execuções': 'Uitvoeringen',
    'Armazém': 'Magazijn',
    'Frota': 'Vloot',
    'Sair': 'Afmelden',
    'Inventário': 'Inventaris',

    // Nova Os
    'Voltar': 'Terug',
    'Nova OS': 'Nieuw WO',
    'Operação': 'Operatie',
    'Placa': 'Kenteken',
    'Segmento': 'Segment',
    'Problemas': 'Problemen',
    'Descrição do Problema': 'Probleembeschrijving',
    'Gerar OS': 'WO Aanmaken',
    'Cancelar': 'Annuleren',

    // OS Interna
    "Nenhum resultado encontrado": "Geen resultaten gevonden",
    "Exibindo resultado": "Resultaten weergegeven",
    "de": "van",
    "Aberta há": "Geopend sinds",
    "Concluída em": "Voltooid op",

    // Ordem Servico
    "Detalhes": "Details",
    "Mostrar": "Tonen",
    "Esconder": "Verbergen",
    "Telefone": "Telefoon",
    "Data": "Datum",
    "Início": "Start",
    "Final": "Einde",
    "Fornecedor": "Leverancier",
    "Tipo": "Type",
    "Ciclo preventiva": "Preventieve cyclus",
    "Criticidade": "Prioriteit",
    "Previsão de Atendimento": "Verwachte behandeling",
    "Atendimento do Item": "Item behandeling",
    "Observações": "Opmerkingen",
    "Imagens": "Afbeeldingen",
    "Salvar": "Opslaan",
    "Ordens de Serviço": "Werkorders",
    "GERADA_CHECKLIST": "GEGENEREERD VANUIT DE CHECKLIST",
    "OBS_CHECKLIST": "OPMERKINGEN VAN DE CHECKLIST:",
    "OS_INTERNA": "INTERNE WERKORDER:",

    // OS Item
    "Iniciar": "Starten",
    "Ações": "Acties",
    "Continuar": "Doorgaan",
    "Pausar": "Pauzeren",
    "Registrar Peças": "Onderdelen registreren",
    "Cancelar OS": "WO annuleren",
    "OS Externa": "Extern WO",
    "Insira um serviço. Tente novamente.": "Voer een dienst in. Probeer opnieuw.",
    "Falha ao carregar os dados da OS": "Mislukt om de WO-gegevens te laden",
    "Falha ao carregar os itens da OS": "Mislukt om de WO-items te laden",

    // ModalItems
    "Serviços": "Diensten",
    "Observação": "Opmerking",
    "Anexo de arquivos": "Bestanden bijvoegen",
    "Informe o valor total dos serviços/peças": "Geef de totale waarde van diensten/onderdelen op",
    "Informe o motivo do socorro em rota": "Geef de reden van hulp onderweg op",
    "Informe o pneu utilizado neste serviço": "Geef de band op die in deze dienst is gebruikt",
    "Foi trocado o pneu": "Band werd vervangen",
    "Finalizar OS": "WO voltooien",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "Zijn er onderdelen gebruikt?",
    "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!": "Als er onderdelen zijn gebruikt, kies 'Ja' hieronder!",
    "Não": "Nee",
    "Sim": "Ja",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Geef de items op die in deze dienst zijn gebruikt",
    "Fechar": "Sluiten",
    "Peças": "Onderdelen",
    "Peça": "Onderdeel",
    "Quantidade": "Aantal",
    "Preço": "Prijs",
    "Informe o pneu novo": "Geef de nieuwe band op",
    
    //Modal Pause
    "Informe a Justificativa": "Geef de rechtvaardiging op",
    "Confirmar Pausa": "Pauze bevestigen",
    "Justificativa": "Rechtvaardiging",
    "Ir ao banheiro": "Naar toilet",
    "Fim de expediente": "Einde werkdag",
    "Atendimento": "Behandeling",
    "Refeição": "Maaltijd",
    "Aguardando Peças": "Wachten op onderdelen",
    "Auxílio externo": "Externe ondersteuning",
    'Selecione qual peça está aguardando': 'Selecteer welk onderdeel in afwachting is',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Extern WO bevestigen",
    "Deseja realmente enviar OS": "Wilt u de werkorder echt verzenden?",
    "Confirmar": "Bevestigen",

    // Lista de Execucao
    "Lista de execução": "Uitvoeringslijst",
    "Nenhuma execução ativa": "Geen actieve uitvoering",
    "Início Atendimento": "Start behandeling",
    "Encerrar OS": "WO afsluiten",
    "Acessar OS": "WO openen",
    "Colaborador": "Medewerker",
    "Execuções em Pause": "Uitvoeringen in pauze",
    "Nenhuma execução em pause": "Geen uitvoering in pauze",

    // Login
    "Torne sua rotina mais dinâmica": "Maak uw routine dynamischer",
    "ACESSO AO SISTEMA": "SYSTEEMTOEGANG",
    "Terminal Oficina": "Werkplaats terminal",
    "Realize o login e tenha acesso ao controle": "Log in voor toegang tot de controle",
    "e gestão de suas Ordens de Serviço": "en beheer van uw werkorders",
    "Mecânico Externo": "Externe monteur",
    "Acessar": "Openen",
    "Falha ao fazer login": "Inloggen mislukt",

    // Filtro Internas
    "Ordenar": "Sorteren",
    "Antigas Primeiro": "Oudste eerst",
    "Recentes Primeiro": "Nieuwste eerst",
    "Maior": "Groter",
    "Menor": "Kleiner",
    "Segmentos": "Segmenten",
    "Período": "Periode",
    "Execução": "Uitvoering",
    "Todos": "Alle",
    "Pendentes": "In afwachting",
    "Finalizadas": "Afgerond",
    "Aplicar filtro": "Filter toepassen",
    "Limpar filtros": "Filters wissen",
    "Esconder filtros": "Filters verbergen",
    "Criado por": "Aangemaakt door",
    "Usuário": "Gebruiker",
    "Ação": "Actie",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filter de preventieve WO's",
    "Preventivas Vencidas": "Verlopen preventieve WO's",
    "Preventivas à Vencer": "Preventieve WO's bijna verlopen",
    "Carrocerias Vencidas": "Verlopen opbouwen",
    "Carrocerias à Vencer": "Carrosserieën om te winnen",
    "Atualizar": "Bijwerken",

    // Modais Preventivas
    "ACAO": "ACTIE",
    "PLACA": "KENTEKEN",
    "PROXIMO_CICLO": "VOLGENDE_CYCLUS",
    "VENCIMENTO": "VERVALDATUM",
    "PROXIMO_KM": "VOLGENDE_KM",
    "KM_ATUAL": "HUIDIGE_KM",
    "Vincular Fornecedor": "Leverancier koppelen",

    // Inventário
    'Iniciar novo inventário': 'Nieuwe inventaris starten',
    'Dt Inicial': 'Begindatum',
    'Dt Final': 'Einddatum',
    "Não contados": "Niet geteld",
    "Contados": "Geteld",
    "Ordenação": "Sortering",
    "Total Itens": "Totaal items",
    "Status": "Status",
    "Inventário criado com sucesso!": "Inventaris succesvol aangemaakt!",
    "Já existe um inventário em execução": "Er is al een inventaris in uitvoering",
    "Deseja iniciar um novo inventário?": "Wilt u een nieuwe inventaris starten?",
    "Inventário de Estoque": "Voorraadinventaris",

    'Precisa de Ajuda?': 'Hulp nodig?',
    'Desejamos um ótimo 2024!': 'Wij wensen u een geweldig 2024!',
    
    'Bem vindo(a) ao Terminal da Borracharia!': 'Welkom bij de bandenservice terminal!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!': 'Beheer banden via de nieuwe bandenservice terminal!',

    'Problema': 'Probleem',
    'Pendente': 'In afwachting',
    'Descartes': 'Afkeuringen',

    "Fora do Prazo": "Buiten termijn",
    "Dentro do Prazo": "Binnen termijn",

    "CALIBRAGEM": "KALIBRATIE",
    "Nunca feito": "Nooit uitgevoerd",
    "FOGO": "POSITIE",
    "Informar Calibragem": "Kalibratie opgeven",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Begin de naam van de leverancier te typen om hieronder weer te geven",

    // Idiomas
    "Portugues": "Portugees",
    "Ingles": "Engels",
    'Frances': "Frans",
    'Alemao': "Duits",
    'Holandes': "Nederlands",
    'Espanhol': 'Spaans',
    
    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "DE INSPANNING VAN VANDAAG IS HET SUCCES VAN MORGEN",

    "CODIGO OS": "WERKOPDRACHTCODE",
    "TODOS": "ALLE",
    "Socorro em Rota pendente de atendimento": "Wegenhulp in afwachting van afhandeling",
    "FILTROS": "FILTERS",
    "Salvar Filtro": "Filter opslaan",
    "Motorista": "Bestuurder",
    "Orçamento": "Budget",
    "Confirmar Orçamento": "Budget bevestigen",
    "Deseja pausar esta OS para aguardar o orçamento?": "Wilt u deze werkopdracht pauzeren om op het budget te wachten?",
    "Valor": "Waarde",
    "Pausar OS": "Werkopdracht pauzeren",
    "Comentarios": "Opmerkingen",
    "Insira um comentário": "Voer een opmerking in",
    "Enviar OS": "Werkopdracht verzenden",
    "Selecione uma justificativa": "Selecteer een rechtvaardiging",
    "Anexos": "Bijlagen",
    "OS Socorro em Rotas": "Wegenhulp werkopdracht",
    "Confirmar Cancelamento": "Annulering bevestigen",
    "Buscar Placa": "Kenteken zoeken",
    "Pesquisa de OS por placa": "Werkopdracht zoeken op kenteken",
    "CONTRATO_CONCESSIONARIA": "CONCESSIEOVEREENKOMST",

    "Ordem gerada com sucesso": "Opdracht succesvol aangemaakt",
    "Sucesso": "Succes",
    "Selecionar Todos": "Alles selecteren",
    "Descrição": "Beschrijving",
    "Registrar Serviços": "Diensten registreren",
    "Visualizar Itens": "Items bekijken",
    "Clique no botão a direita para registrar as peças": "Klik op de knop rechts om de onderdelen te registreren",

    "Selecionar técnico": "Technicus selecteren",
    "KM atual/Horimetro": "Huidige kilometerstand / urenteller",
    "Deseja inserir alguma imagem no atendimento": "Wilt u een afbeelding aan de service toevoegen?",
    "Para concluir a ação, selecione abaixo o técnico responsável": "Selecteer hieronder de verantwoordelijke technicus om de actie te voltooien",
    "Trabalhando": "Bezig",
    "Matricula": "Registratienummer",
    "Serviços registrado com sucesso": "Diensten succesvol geregistreerd",
    "Função": "Functie",
    "Enviar Anexos": "Bijlagen verzenden",
    "Gerar Preventiva Programada": "Geplande preventieve onderhoudsbeurt genereren",
    "OS Preventiva Programada": "Geplande preventieve werkopdracht",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Voltooi alle onderdelen en diensten om de service af te sluiten",
    "Insira um KM maior que o anterior": "Voer een kilometerstand in die hoger is dan de vorige",
    "Insira um KM maior que o atual": "Voer een kilometerstand in die hoger is dan de huidige",
    "Inserir anexos": "Bijlagen toevoegen",
    "Planos Preventivos": "Preventieve plannen",
    "Filtro": "Filter",
    "ULTIMA": "LAATSTE",
    "Gerar Preditiva": "Predictief onderhoud genereren",
    "Carregando": "Laden",
    "OS Preventiva Programada Armazém": "Geplande preventieve werkopdracht – Magazijn",
    "Gerar OS Preventiva Programada": "Geplande preventieve werkopdracht genereren",
    "OS Preventivas à Vencer": "Preventieve werkopdrachten die bijna verlopen",
    "OS de Transição": "Overgang besturingssysteem",

    "IMEDIATA": "ONMIDDELLIJK",
    "EMERGENCIAL": "NOODGEVAL",
    "ALTA": "HOOG",
    "MÉDIA": "GEMIDDELD",
    "LEVE": "LAAG",

    "Registrar Tarefas": "Taken Registreren",
    "Desbloqueia Empilhadeira": "Heftruck Deblokkeren",
    "OS Ag. Aprovação": "WO in Afwachting van Goedkeuring",
    "OS Internas Veículos": "Interne WO – Voertuigen",
    "OS Internas Armazém": "Interne WO – Magazijn",
    "OS Reabertas": "Heropende WO",
    "Criticidade de OS Abertas": "Kriticiteit van Open WO",
    "Top 20 Placas com mais OS": "Top 20 Kentekens met Meeste WO",
    "Qtd OS": "Aantal WO",

    // Dashboard
    "Criticidade de OS abertas": "Kriticiteit van open WO",
    "URGENTE": "DRINGEND",
    "PREVENTIVA": "PREVENTIEF",
    "CRITICIDADES": "KRITICALITEITEN",
    "Bem Vindo(a)": "Welkom",
    "Tenha acesso as principais": "Krijg toegang tot de belangrijkste",
    "informações da sua mecânica!": "informatie van uw werkplaats!",
    "Ver OS internas": "Interne WO bekijken",
    "OS TicketLog": "TicketLog WO",
    "OS Externas": "Externe WO",
    "OS Interna Veículos": "Interne WO Voertuigen",
    "OS Interna Armazém": "Interne WO Magazijn",
    "Ranking dos Mecânicos": "Monteur Ranglijst",
    "Tipo de OS": "WO Type",
    "Atendidas nos últimos 30 dias": "Afgehandeld in de afgelopen 30 dagen",
    "TOP 20 Placas com mais OS": "TOP 20 Kentekens met meeste WO",
    "Últimos 30 dias": "Afgelopen 30 dagen",
    "Placas com OS Externas": "Kentekens met externe WO",
    "TOP 10 Problemas mais atendidos": "TOP 10 Meest behandelde problemen",
    "Nos últimos 30 dias": "In de afgelopen 30 dagen",
    "Status por Mecânico": "Status per Monteur",
    "Produtividade": "Productiviteit",

    // ModalEncerradas
    "Filtros": "Filters",
    "NÚMERO": "NUMMER",
    "INÍCIO": "START",
    "FINAL": "EINDE",
    "SEGMENTO": "SEGMENT",
    "PROBLEMA": "PROBLEEM",
        
    // Login
    "Acesso Rápido": "Snelle toegang",
    "ID": "ID",
    "codigo_fornec": "code",
    "Para qual fornecedor você deseja enviar esta OS": "Naar welke leverancier wilt u deze bestelling sturen?",
    'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': 'Als er onderdelen zijn gebruikt bij deze service, klik dan op "Ja" bij de onderstaande optie!',
    "FILTRO EMPRESA": "BEDRIJFSFILTER",
    "Upload Arquivos": "Bestanden uploaden",
    "Cards": "Kaarten",
    "Colunas": "Kolommen",
    "FILIAL": "FILIAAL",
    "MARCA": "MERK",
    "ULTIMA MM": "LAATSTE MM",
    "PRÓXIMA MM": "VOLGENDE MM",
    "ULTIMA CAL": "LAATSTE CAL",
    "PRÓXIMA CAL": "VOLGENDE CAL",
    "ULTIMA MOVIMENTACAO": "LAATSTE BEWEGING",
    "PRÓXIMA MOVIMENTACAO": "VOLGENDE BEWEGING",
    "N° FOGO": "N° FOGO",
    "MODELO": "MODEL",
    "MEDIDA": "MAAT",
    "POSIÇÃO": "POSITIE",

}
